module.exports = __webpack_public_path__ + "assets/modefit.93935c2e.svg";